


























import BaseComponent from "@/asdcom/BaseComponent";
import { Prop, Component, Watch, Emit } from "vue-property-decorator";
import { IHeader } from "@/store/models/staff/IHeader";
import MasterDetailsComponent from "@/components/vcponlineok/staff-user/master-details-component.vue";
import { PagedResultDtoOfVcClaimLogDto } from "@/asdcom/apiproxy/apiproxy.dto";

@Component({components:{MasterDetailsComponent}})
export default class ReminderListComponent extends BaseComponent {
  @Prop({
    default: () => {}
  })
  viewModel?: PagedResultDtoOfVcClaimLogDto; 

  headers: IHeader[] = [
    { text: "Claim Number", value: "claimNumber", align: "center" },
    { text: "Type", value: "eventType", align: "center" },
    { text: "Created By", value: "creatorUserFullName", align: "center" },
    { text: "Created", value: "creationTime", align: "center" },
    { text: "Due", value: "dueDate", align: "center" },
  ];

  get listData() {
    if (this.viewModel !== undefined) {
      return this.viewModel.items;
    }
  }

  private onListRowClick(item: any) {
    if (!!item.claimNumber) {
      this.$router.push({
        name: "ClaimLog",
        params: { claimNumber: item.claimNumber }
      });
    }
  }

}
